module.exports = __webpack_public_path__ + "img/logo_minpre.6f833e4d.png";